<script setup lang="ts">
// for some reason SVGO optimises away `stroke="none"` on `circle`, if there's also a path
// after spending 1 hour trying to get it to work, I decided to just make this component and make the circle myself
</script>
<template>
  <div class="rounded-full bg-emerald-400 p-0.5">
    <SvgoPikaCheck class="text-white" />
  </div>
</template>
